/**
 * Value Props block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS alongside its JS,
 * so the theme ships both together.
 *
 * The only behaviour is the entrance: the section sits below the fold, so a
 * plain CSS animation would have played out before anyone scrolled to it. The
 * `data-reveal` attribute is set here and only here — with the script blocked
 * the attribute never appears and the section renders in full.
 */

import './index.scss';

const sections = document.querySelectorAll('.value-props');

if (sections.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    entry.target.setAttribute('data-reveal', 'in');
                    observer.unobserve(entry.target);
                }
            }
        },
        { rootMargin: '0px 0px -15% 0px' }
    );

    for (const section of sections) {
        section.setAttribute('data-reveal', 'pending');
        observer.observe(section);
    }
}
